import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "booking-panel" }
const _hoisted_2 = { class: "booking-panel__title" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-adult me-2 text-primary booking-panel__title-icon",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_4 = { class: "booking-panel__body" }
const _hoisted_5 = { class: "mb20" }
const _hoisted_6 = { class: "row gx-0" }
const _hoisted_7 = { class: "col-6 align-self-center" }
const _hoisted_8 = { class: "persons-spinner__main" }
const _hoisted_9 = { class: "persons-spinner__ageinfo" }
const _hoisted_10 = { class: "col-6" }
const _hoisted_11 = { class: "" }
const _hoisted_12 = { class: "row gx-0" }
const _hoisted_13 = { class: "col-6 align-self-center" }
const _hoisted_14 = { class: "persons-spinner__main" }
const _hoisted_15 = { class: "persons-spinner__ageinfo" }
const _hoisted_16 = { class: "col-6" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "h3 mb-3 mt-4 mt-md-5 text-center" }
const _hoisted_19 = { class: "row gx-0 mb10" }
const _hoisted_20 = { class: "col-6 align-self-center" }
const _hoisted_21 = { class: "persons-spinner__main" }
const _hoisted_22 = { class: "col-6" }

import {ref, computed, watch} from 'vue';
import {storeToRefs} from 'pinia';
import NumberSpinner from "./NumberSpinner.vue";
import {useBookingDataStore} from "../stores/BookingDataStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'PeopleView',
  setup(__props) {

const bookingDataStore = useBookingDataStore();

const {adults, children, childrenAges, nextButtonDisabled, childDefaultAge } = storeToRefs(bookingDataStore);

// improvement: with a Composition API store, this could be put into the store itself
// set as many children ages as there are children, children could also be removed
// children could also be set directly, so the delta should be added or removed
watch(children, () => {
    if (children.value > childrenAges.value.length) {
        for (let i = childrenAges.value.length; i < children.value; i++) {
            childrenAges.value.push(childDefaultAge.value);
        }
    } else if (children.value < childrenAges.value.length) {
        childrenAges.value.splice(children.value);
    }
})

watch([adults, children], () => {
    nextButtonDisabled.value = (adults.value + children.value) <= 0;
}, {immediate: true})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createTextVNode(_toDisplayString(_ctx.$translate('rent_site.location.booking-widget.persons.label')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$translate('rent_site.location.persons.age-group.headline-adults')), 1),
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$translate('rent_site.location.persons.age-group.from-age', { age: _unref(bookingDataStore).selectedLocation.adultMinAge })), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(NumberSpinner, {
              min: 0,
              max: 15,
              value: _unref(adults),
              modelValue: _unref(adults),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(adults) ? (adults).value = $event : null)),
              id: "bookingWidgetAdults"
            }, null, 8, ["value", "modelValue"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$translate('rent_site.location.persons.age-group.headline-children')), 1),
            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$translate('rent_site.location.persons.age-group.till-age', { age: _unref(bookingDataStore).selectedLocation.childMaxAge })), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(NumberSpinner, {
              min: 0,
              max: 10,
              value: _unref(children),
              modelValue: _unref(children),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(children) ? (children).value = $event : null)),
              id: "bookingWidgetChildren"
            }, null, 8, ["value", "modelValue"])
          ])
        ])
      ]),
      (_unref(children) > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$translate('rent_site.location.persons.age-group.age-regulation.pickup-date')), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(childrenAges), (childAge, index) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$translate('rent_site.location.persons.age-group.label-child')) + " " + _toDisplayString(index + 1), 1)
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(NumberSpinner, {
                    min: _unref(bookingDataStore).selectedLocation.childMinAge,
                    max: _unref(bookingDataStore).selectedLocation.childMaxAge,
                    value: childAge,
                    modelValue: _unref(childrenAges)[index],
                    "onUpdate:modelValue": ($event: any) => ((_unref(childrenAges)[index]) = $event),
                    id: `bookingWidgetChildrenAge${index}`
                  }, null, 8, ["min", "max", "value", "modelValue", "onUpdate:modelValue", "id"])
                ])
              ]))
            }), 256))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})